"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: add aggregates?
// TODO: can't find a way to use these values as string types in the interfaces
exports.types = Object.freeze({
    ALT: 'alt',
    ASK: 'ask',
    BGP: 'bgp',
    CONSTRUCT: 'construct',
    DESC: 'desc',
    DESCRIBE: 'describe',
    DISTINCT: 'distinct',
    EXPRESSION: 'expression',
    EXTEND: 'extend',
    FILTER: 'filter',
    FROM: 'from',
    GRAPH: 'graph',
    GROUP: 'group',
    INV: 'inv',
    JOIN: 'join',
    LEFT_JOIN: 'leftjoin',
    LINK: 'link',
    MINUS: 'minus',
    NPS: 'nps',
    ONE_OR_MORE_PATH: 'OneOrMorePath',
    ORDER_BY: 'orderby',
    PATH: 'path',
    PATTERN: 'pattern',
    PROJECT: 'project',
    REDUCED: 'reduced',
    SEQ: 'seq',
    SERVICE: 'service',
    SLICE: 'slice',
    UNION: 'union',
    VALUES: 'values',
    ZERO_OR_MORE_PATH: 'ZeroOrMorePath',
    ZERO_OR_ONE_PATH: 'ZeroOrOnePath',
});
exports.expressionTypes = Object.freeze({
    AGGREGATE: 'aggregate',
    EXISTENCE: 'existence',
    NAMED: 'named',
    OPERATOR: 'operator',
    TERM: 'term',
    WILDCARD: 'wildcard',
});
//# sourceMappingURL=algebra.js.map